import Slides from './slides';
import NormalSlides from './normalSlides';
import BottomSlides from './bottomSlides';
import ShareSlides from './shareSlides';
import IndexSlides from './indexSlides';
import UpgradeBottomSlides from './upgradeBottomSlides';

export { Slides, NormalSlides, BottomSlides, ShareSlides, IndexSlides, UpgradeBottomSlides };
